<script setup>
import {formatDate,formatAmount, formatNumber} from "../../helper";
import {useI18n} from "vue-i18n";

const props = defineProps({
  instructions: {
    type: Array,
  }
});

const {t} = useI18n();
</script>

<template>
  <div class="table-container">
    <table class="table table--last-to-right table--cells-py-0">
      <thead>
      <tr>
        <th scope="col">
          {{ t('instructionsTable.date') }}
          <div class="table__sub-value">{{ t('instructionsTable.instruction_reference') }}</div>
        </th>
        <th scope="col">
          {{ t('instructionsTable.instruction_transaction_type') }}
          <div class="table__sub-value">{{ t('instructionsTable.isin') }}</div>
        </th>
        <th scope="col">
           {{ t('instructionsTable.strategy') }}
          <div class="table__sub-value">{{ t('instructionsTable.amount') }} | {{ t('instructionsTable.quantity') }} | {{ t('instructionsTable.price') }}</div>
        </th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="instruction of instructions" :key="instruction">
        <td>
          {{ formatDate(instruction.instruction_transaction_datetime, 'd.m.Y H:i') }}
          <div v-if="instruction.instruction_reference" class="table__sub-value">{{ instruction.instruction_reference }}</div>
        </td>
        <td>
          {{ instruction.instruction_transaction_type.transaction_type }}
          <div class="table__sub-value">{{ instruction.isin }}</div>
        </td>
        <td>
          {{ instruction.contract_strategy?.strategy?.name }}
          <div class="table__sub-value">{{ formatAmount(instruction.amount, instruction.currency, 2, true) }} | {{ formatNumber(instruction.quantity, 5, true) }} ks | {{ formatAmount(instruction.amount / instruction.quantity, instruction.currency, 2, true) }}</div>
        </td>
      </tr>
      <tr v-if="!instructions?.length">
        <td colspan="3" class="table__empty-td">
          <div class="table__empty-text">
            {{ t('instructionsTable.no_instructions_yet') }}
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<style scoped>
</style>